import { dropItemMap } from "../constants/dropItemMap"

export const findDropItemByIdCfg = (idCfg, type) => {
    if (type == null) {
        const item = dropItemMap.options.find(option => option.value === idCfg);
        return item;
    } else {
        const item = dropItemMap.options.find(option => option.value === idCfg && option.type === type);
        // console.log('findDropItemByIdCfg', item, idCfg, type)
        return item;
    }
}
export const stringToShort = (inputString, showLenght) => {
    if (!inputString) return inputString;
    // console.log('stringToShort 1')
    if (!(typeof inputString === 'string')) return inputString;
    // console.log('stringToShort 2', showLenght)
    const maxLenght = !showLenght ? 9 : showLenght;
    const inputLenght = inputString.length;
    if (maxLenght >= inputLenght) return inputString;
    const shortString = inputString.substring(0, maxLenght - 3) + "..."
    // console.log('stringToShort', shortString, inputLenght, maxLenght)
    return shortString
}
